module.exports = __webpack_public_path__ + "img/Icon__Province_1.751694bc.svg";